module.exports = __webpack_public_path__ + "static/media/(DH)-Artesanato-20.40bdb45b.jpg";